import React, { useEffect, useState } from 'react';

import { useMutation } from '@apollo/client';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { Col, Row } from 'reactstrap';

import Toast from '../../../components/Toast/Toast';
import affairesQueries from '../../../services/affaires/affaires';
import AssignmentContext from './assignment.context';

const TakeLeadButton = props => {
  const [createAffaire, createAffaireMutation] = useMutation(affairesQueries.Mutation.createAffaire);
  const [toastMessage, setToastMessage] = useState(false);
  const [checkCGV, setCheckedCGV] = useState(true);
  const { taken, setTaken, rejected, setUrlAffaire } = React.useContext(AssignmentContext);
  const opportunityTaken = props?.lead?.taken || taken;
  const opportunityRejected = props?.lead?.rejected || rejected;
  const externalAffaire = {
    id: props?.lead?.externalAffaireId || createAffaireMutation?.data?.createAffaireWithOpportunityAssigmentId?.id,
    url: props?.lead?.externalAffaireUrl || createAffaireMutation?.data?.createAffaireWithOpportunityAssigmentId?.url,
  };

  useEffect(() => {
    if (externalAffaire && externalAffaire.url) {
      setUrlAffaire(externalAffaire.url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setUrlAffaire]);

  const onClick = async () => {
    if (!checkCGV) {
      return;
    }
    try {
      const response = await createAffaire({
        variables: {
          opportunityAssignmentId: props.lead.id,
          skipAttributionService: false,
        },
      });
      if (!response.data.createAffaireWithOpportunityAssigmentId.id) {
        throw Error(response.data.createAffaireWithOpportunityAssigmentId.message);
      }
      setTaken(true);
    } catch (error) {
      if (error.message === 'The lead is already taken.') {
        setToastMessage('Désolé, ce lead a déjà été accepté.');
      } else {
        setToastMessage(createAffaireMutation?.error?.message || error.message);
      }
    }
  };

  return (
    <>
      {!externalAffaire.id && !opportunityRejected && !opportunityTaken && (
        <>
          {props.billingType !== 'FREE' && (
            <>
              <Row>
                <Col>
                  <FormGroup check className='checkbox'>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checkCGV}
                          onChange={() => setCheckedCGV(!checkCGV)}
                          icon={<CheckBoxOutlineBlankIcon fontSize='large' />}
                          checkedIcon={<CheckBoxIcon fontSize='large' />}
                          name='checkbox'
                        />
                      }
                      label="J'accepte les CGV ToutvaBiens"
                    />
                  </FormGroup>
                </Col>
                <Col className='mt-2'>
                  <a href={`#/cgv-drimki`} style={{ color: '#23282C' }}>
                    <span>Voir les CGV ToutvaBiens</span>
                  </a>
                </Col>
              </Row>
            </>
          )}
          <button
            className='btn btn-success mr-2 mt-2 btn-block'
            type='button'
            onClick={onClick}
            disabled={checkCGV ? '' : 'disabled'}
          >
            {createAffaireMutation.loading ? (
              <span>
                <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'>
                  {' '}
                </span>
                &nbsp;&nbsp;Création d'affaire en cours
              </span>
            ) : (
              <span>Je prends le lead</span>
            )}
          </button>
        </>
      )}
      {toastMessage && <Toast error={toastMessage} />}
    </>
  );
};

export default TakeLeadButton;
